module.exports = __webpack_public_path__ + "img/spaghetti-carbonara.360524f1.jpeg";